import { render, staticRenderFns } from "./veJkyResourceShow.vue?vue&type=template&id=54c3d7e6&scoped=true"
import script from "./veJkyResourceShow.vue?vue&type=script&lang=js"
export * from "./veJkyResourceShow.vue?vue&type=script&lang=js"
import style0 from "./veJkyResourceShow.vue?vue&type=style&index=0&id=54c3d7e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3d7e6",
  null
  
)

export default component.exports